"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
// import app components
const colors_1 = __importDefault(require("../../../theme/colors"));
const Footer = (props) => {
    const { items, linkComponent } = props;
    return (react_1.default.createElement(material_1.Box, { sx: {
            height: "4rem",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 3,
        } }, items?.map((item, i) => (react_1.default.createElement(material_1.Link, { component: linkComponent, href: item.url, key: i, variant: "overline", sx: {
            textDecoration: "none",
            color: colors_1.default.text[600],
            "&:hover": { color: colors_1.default.primary[900] },
            m: "1rem",
        } }, item.label)))));
};
exports.default = Footer;
